import { packageCostTry } from './creditCurrency';

export const CREDIT_PRESET_MONTHS = [3, 6, 12, 24, 36, 48, 999];

export function getCreditPackagePresets({ pricing, maxConnections, isReseller = false, resellerDiscount = 0 }) {
  const tier = Number(maxConnections);
  // Resellers use the same live catalog (their account tariff is TRY); the discount applies on top of it.
  const plans = pricing?.available ? pricing.plans.filter((plan) => plan.max_connections === tier) : [];
  const discount = isReseller && Number(resellerDiscount) > 0 ? Number(resellerDiscount) : 0;

  return CREDIT_PRESET_MONTHS.map((duration) => {
    const plan = plans.find((item) => item.duration === duration);
    const price = plan && typeof plan.price === 'number' && plan.price > 0
      ? plan.price - (plan.price * discount / 100) : null;
    // POS and the credit ledger remain TRY, including for EUR account tariffs.
    const cost = price === null ? null : packageCostTry(price, pricing.currency, pricing?.eur_try_rate);
    return { duration, nativeAmount: price, amount: cost !== null && cost > 0 ? Math.round(cost * 100) / 100 : null };
  });
}
